export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  INTERNAL_CHAT_MENTION: ['i-lucide-at-sign', 'text-n-blue-11'],
  INTERNAL_CHAT_NEW_MESSAGE: ['i-lucide-message-square-plus', 'text-n-blue-11'],
  CONVERSATION_ESCALATED: ['i-lucide-siren', 'text-n-ruby-11'],
  ESCALATED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-warning',
    'text-n-ruby-11',
  ],
};
